import React, { Fragment } from "react";
import Header from "../header/Header";
import PageTitle from "../pagetitle/PageTitle";
import Footer from "../footer/Footer";
import Scrollbar from "../scrollbar/scrollbar";
import Mcc from "../mcc/Mcc";
// import blog2 from "../../images/blog/blogDetailsSmall1.jpg";
// import blog1 from "../../images/blog/blogDetails1.jpg";
// import blog3 from "../../images/blog/blogDetailsSmall2.jpg";
import medeelel from "../../api/medee-medeelel";
import { Link, useParams } from "react-router-dom";
import BlogSidebar from "../BlogSidebar";
import Aldaa404 from "../../main-component/404/404";

const MedeeDetails = ({ isDark, onToggleDark }) => {
  const { slug } = useParams();

  const medeeIndex = medeelel.findIndex((item) => item.slug === slug);
  const medeeDetails = medeelel[medeeIndex];

  const prevMedee = medeelel[medeeIndex - 1];
  const nextMedee = medeelel[medeeIndex + 1];

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  if (!medeeDetails) {
    return <Aldaa404 isDark={isDark} onToggleDark={onToggleDark} />;
  }

  return (
    <Fragment>
      <Header isDark={isDark} hclass={"header--styleFour"} />
      <main className="main">
        <PageTitle
          pageTitle={medeeDetails.title}
          pagesub={`мэдээ / ${medeeDetails.slugmn}`}
          pageTop={"Blog"}
          tolink={"#medeedetails"}
        />
        <section id="medeedetails" className="stories pt-70 pb-40">
          <Mcc />
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mb-30">
                <div className="innerWrapper">
                  <div className="donationDetails storiesDetails">
                    <div className="donationDetails__header mb-45">
                      <figure className="thumb mb-45">
                        <img src={medeeDetails.screens} alt="mcc" />
                      </figure>
                    </div>
                    <p className="donationDetails__text storiesDetails__text mb-30">
                      {medeeDetails.description}
                    </p>
                    {medeeDetails.screen3 ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <figure className="thumb mb-40">
                            <img src={medeeDetails.screen3} alt="mcc-medee" />
                          </figure>
                        </div>
                      </div>
                    ) : null}
                    <p className="donationDetails__text storiesDetails__text mb-30">
                      {medeeDetails.description2}
                    </p>

                    <div className="blogDetails-nextPrevious">
                      <div className="row">
                        {/* Өмнөх мэдээ */}
                        {prevMedee && (
                          <div className="col-lg-6 mb-40">
                            <div className="blogDetails-title mb-25">
                              <h3 className="blogDetails-title__heading text-uppercase">
                                <Link
                                  onClick={ClickHandler}
                                  to={`/medee-medeelel/${prevMedee.slug}`}
                                >
                                  <i className="fa-solid fa-angles-left"></i>{" "}
                                  Өмнөх
                                </Link>
                              </h3>
                            </div>
                            <div className="blogBlockSmall blogBlockSmall--style2">
                              <figure className="blogBlockSmall__thumb">
                                <Link
                                  onClick={ClickHandler}
                                  to={`/medee-medeelel/${prevMedee.slug}`}
                                >
                                  <img src={prevMedee.screens2} alt="mcc" />
                                </Link>
                              </figure>
                              <div className="blogBlockSmall__content">
                                <h3 className="blogBlockSmall__heading">
                                  <Link
                                    onClick={ClickHandler}
                                    to={`/medee-medeelel/${prevMedee.slug}`}
                                  >
                                    {prevMedee.title}
                                  </Link>
                                </h3>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Дараагийн мэдээ */}
                        {nextMedee && (
                          <div
                            className={`${
                              !prevMedee ? "col-lg-12 text-end" : "col-lg-6"
                            } mb-40`}
                          >
                            <div className="blogDetails-title mb-25 text-end">
                              <h3 className="blogDetails-title__heading text-uppercase">
                                <Link
                                  onClick={ClickHandler}
                                  to={`/medee-medeelel/${nextMedee.slug}`}
                                >
                                  Дараагийнх{" "}
                                  <i className="fa-solid fa-angles-right"></i>
                                </Link>
                              </h3>
                            </div>
                            <div className="blogBlockSmall blogBlockSmall--style2">
                              <div className="blogBlockSmall__content text-end">
                                <h3 className="blogBlockSmall__heading">
                                  <Link
                                    onClick={ClickHandler}
                                    to={`/medee-medeelel/${nextMedee.slug}`}
                                  >
                                    {nextMedee.title}
                                  </Link>
                                </h3>
                              </div>
                              <figure className="blogBlockSmall__thumb">
                                <Link
                                  onClick={ClickHandler}
                                  to={`/medee-medeelel/${nextMedee.slug}`}
                                >
                                  <img src={nextMedee.screens2} alt="mcc" />
                                </Link>
                              </figure>
                            </div>
                          </div>
                        )}
                      </div>
                      <hr className="ourHr m-0" />
                    </div>

                    <hr className="ourHr m-0" />
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <BlogSidebar />
            </div>
          </div>
        </section>
      </main>
      <Footer isDark={isDark} onToggleDark={onToggleDark} />
      <Scrollbar />
    </Fragment>
  );
};

export default MedeeDetails;
